module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-10.236c28fc.png";